import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Wapper } from "@/components/Layout";
import { getLocationParamer } from "@/utils/common";
// import { Player } from '@lottiefiles/react-lottie-player';
import Lottie from "lottie-react";
import NetworkFinal from "./svg/NetworkFinal.json";
import Success from "./svg/Success.json";
import "./style.scss";

const NotificationOfAppAssociate = ({ title, type }) => {
    const { t } = useTranslation();
    const status = getLocationParamer("status");
    const curTitle =
        status === "fail" && type === "change"
            ? "LB_RESET_SUCCESS_TITLE1"
            : title;
    const appType = getLocationParamer("appType");

    // const changeSuccess = () => {
    //     if (window?.ForgotPasswordJSBridge) {
    //         window?.ForgotPasswordJSBridge?.loginTrigger();
    //         window?.ForgotPasswordJSBridge?.logout();
    //     }
    // };
    const handleSuccess = () => {
        if (window?.CommonJSBridge) {
            window?.CommonJSBridge?.closeWebView?.();
        }
    };

    useEffect(() => {
        if (window?.CommonJSBridge) {
            window?.CommonJSBridge?.showBackButton?.(false);
            window?.CommonJSBridge?.hideCancelButton?.(false);
        }
    }, []);

    return (
        <Wapper
            className={`notification-container ${appType}`}
            title={curTitle}
        >
            <div className="topInfo">
                <Lottie
                    className="Lottie"
                    animationData={status === "fail" ? NetworkFinal : Success}
                    loop={true}
                />
                {/* <div className="img" /> */}
                <div className="title">
                    {status === "fail"
                        ? t("Activation_Unsuccessful")
                        : t("Activation_Successful")}
                </div>
                <div className="desc">
                    {status === "fail" ? (
                        t("CHANGEPASSWORD_LATER")
                    ) : (
                        <>
                            &nbsp;&nbsp;&nbsp;
                            <span>{t("ACTIVATION_SUCCESS_CONTENT")}</span>
                        </>
                    )}
                </div>
            </div>
            <div className="bottomInfo">
                <div className="loginBtn" onClick={handleSuccess}>
                    {t(
                        status === "fail"
                            ? "CHANGEPASSWORD_TRY"
                            : "LB_RESET_SUCCESS_BUTTON"
                    )}
                </div>
            </div>
        </Wapper>
    );
};

export default NotificationOfAppAssociate;
